import React, { useState } from "react";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { SliderPanel } from "../../../../../components";
import SourceSplitupContainer from "../../../SourceSplitupContainer";
import SourceSplitupSummary from "./SourceSplitupSummary";

const SourceWiseSplitUpSliderPanel = ({
  splitupOpen,
  setSplitupOpen,
  values,
  overnightDelivery,
  sourceSplit,
  totalRequestedAmount,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div>
      <div
        className="disp-flex-row"
        style={{
          justifyContent: "space-between",
          color: "#333333",
          fontWeight: "500",
          fontSize: "16px",
        }}
      >
        <p>Source Wise Split-ups</p>
      </div>
      <div
        style={{
          border: "1px solid #BDBDBD",
          width: "100%",
          paddingLeft: "15px",
          borderRadius: "3px",
          overflow: "hidden",
        }}
      >
        <Tab.Container id="left-tabs-example" defaultActiveKey={0}>
          <Row>
            <Col
              sm={3}
              style={{
                background: "#F0F0F0",
                margin: "0px",
                padding: "0px",
                height: "85vh",
              }}
            >
              <div
                style={{
                  padding: "22px 0px 0px 36px",
                  borderBottom: "0.5px solid #A29F9F",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#3B3B3B",
                  }}
                >
                  Source Name
                </p>
              </div>
              <Nav
                variant="pills"
                className="flex-column"
                style={{
                  margin: "15px 0px 0px 0px",
                  padding: "0px",
                  width: "100%",
                }}
              >
                {sourceSplit?.map((data, index) => (
                  <Nav.Item
                    style={{
                      margin: "0px",
                      padding: "0px",
                      width: "100%",
                    }}
                  >
                    <Nav.Link
                      eventKey={index}
                      style={{
                        paddingLeft: "30px",
                        borderRadius: "0px",
                        fontSize: "16px",
                        fontWeight: "500",
                        color: index == activeIndex ? "#307BF6" : "#3B3B3B",
                        backgroundColor:
                          index == activeIndex ? "white" : "#F0F0F0",
                        borderLeft: index == activeIndex && "2px solid #307BF6",
                      }}
                      onClick={() => setActiveIndex(index)}
                    >
                      {index == 0 ? data.tabName : data.sourceName}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                {sourceSplit?.map((data, index) => {
                  if (index == 0) {
                    return (
                      <Tab.Pane eventKey={index}>
                        <SourceSplitupSummary
                          totalRequestedAmount={totalRequestedAmount}
                          data={data}
                        />
                      </Tab.Pane>
                    );
                  } else
                    return (
                      <Tab.Pane eventKey={index}>
                        <SourceSplitupContainer
                          data={data}
                          values={values}
                          module={"loans"}
                          overnightDelivery={overnightDelivery}
                        />
                      </Tab.Pane>
                    );
                })}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </div>
  );
};

export default SourceWiseSplitUpSliderPanel;
